import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../store';

export interface Tag {
  push: any;
  filterTag: any;
}

const initialState: Tag = {
  filterTag: [],
  push: undefined,
};

const filterTagSlice = createSlice({
  name: 'filterTag',
  initialState,
  reducers: {
    changeFilterTagState: (state, action: PayloadAction<Tag>) => {
      return action.payload;
    },
  },
});

export const { changeFilterTagState } = filterTagSlice.actions;
export const getFilterTagSelector = (state: RootState) => state.filterTag;
export default filterTagSlice.reducer;
